import m from 'mithril'
import {t} from 'store'
import {Component, action} from '@codeurs/front'
import Button from 'views/layout/button'
import ContainerTitle from 'views/layout/containertitle'
import Event, {EventType} from './event'

import './eventscontainer.less'

export default class EventsContainer extends Component<{
	events: Array<EventType>
	lists: any
}> {
	view() {
		const {events} = this.attrs

		return m('.eventscontainer',
			events[0] && [
				m('.eventscontainer-flex', [
					m(ContainerTitle, {
						className: 'eventscontainer-flex-title',
						text: t('events.upcomingevents')
					}),
					m('.eventscontainer-flex-events', this.getEvents())
				]),
				m(Button,
					{...action('/events'), mod: 'more arrow'},
					t('events.moreevents')
				)
			]
		)
	}
	getEvents() {
		const {events, lists} = this.attrs
		return events.map(event => {
			return m('.eventscontainer-flex-events-event', [
				m(Event, {event, lists}),
				m('.eventscontainer-flex-events-event-border.border')
			])
		})
	}
}
